import { render, staticRenderFns } from "./DirectInvestmentForm.vue?vue&type=template&id=0081c73d&scoped=true"
import script from "./DirectInvestmentForm.vue?vue&type=script&lang=js"
export * from "./DirectInvestmentForm.vue?vue&type=script&lang=js"
import style0 from "./DirectInvestmentForm.vue?vue&type=style&index=0&id=0081c73d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081c73d",
  null
  
)

export default component.exports